export enum OptionsType {
  CUSTOM = 0,
  ACTIVITIES = 1,
  CERTIFICATIONS = 2
}
